const KEY = "dg_member_email";
export const MEMBER_EMAIL_EVENT = "dg-member-email";

export function getRememberedEmail() {
  return localStorage.getItem(KEY) || "";
}

export function rememberMemberEmail(email) {
  const clean = (email || "").trim().toLowerCase();
  if (!clean || clean === getRememberedEmail()) return;
  localStorage.setItem(KEY, clean);
  window.dispatchEvent(new Event(MEMBER_EMAIL_EVENT));
}

export function forgetMemberEmail() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(MEMBER_EMAIL_EVENT));
}
